<template>
  <v-flex xs12 class="my-2">
    <v-tabs
      right
      class="r5"
      v-model="tab"
      color="grey6"
      :ripple="false"
      slider-color="primary"
      active-class="v-tabs__item--active primary cr-team-shadow white--text"
    >
      <v-tab href="#balance">{{ $t("balance") }}</v-tab>
      <v-tab href="#send_transfers">{{ $t("send_transfers") }}</v-tab>
      <v-tab href="#received_transfers">{{ $t("received_transfers") }}</v-tab>
      <v-tab href="#transfers">{{ $t("transfers") }}</v-tab>
      <v-spacer />
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <v-tab-item value="balance">
        <all-transactions
          @saved="saved"
          v-bind="{
            account,
            customer,
            end_date,
            start_date,
            transactions,
            initList: false,
            accountView: true,
          }"
        >
          <template slot="picker">
            <!-- <div class="di-flex align-start"> -->
            <v-date
              singleLine
              :hideDetails="true"
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="start_date"
              input_id="start_date_tr"
              value-type="YYYY-MM-DD"
              @input="getTransactions"
              :placeholder="$t('from_date')"
              class="flex xs12 md2 mt-1 hide-details"
            />
            <v-date
              singleLine
              :hideDetails="true"
              :clearable="false"
              v-model="end_date"
              format="YYYY-MM-DD"
              input_id="end_date_tr"
              value-type="YYYY-MM-DD"
              @input="getTransactions"
              :placeholder="$t('to_date')"
              class="flex xs12 md2 mx-1 mt-1 hide-details"
            />
            <!-- </div> -->
          </template>
        </all-transactions>
      </v-tab-item>
      <v-tab-item value="send_transfers">
        <send-transfers
          type="send"
          @saved="saved"
          v-bind="{
            initList: false,
            accountView: true,
            transfers: sendTransfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>
      <v-tab-item value="received_transfers">
        <receive-transfers
          type="receive"
          @saved="saved"
          label="transaction_transfers"
          v-bind="{
            initList: false,
            accountView: true,
            transfers: receivedTransfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>
      <v-tab-item value="transfers">
        <transfers
          @saved="saved"
          label="transaction_transfers"
          v-bind="{
            initList: false,
            accountView: true,
            transfers: transfers,
            st_date: start_date,
            en_date: end_date,
          }"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-flex>
</template>

<script>
import sendTransfers from "@/views/roznamcha/tabs/sendTransfers";
import transfers from "@/views/roznamcha/tabs/transfers";
import receiveTransfers from "@/views/roznamcha/tabs/receiveTransfers";
import allTransactions from "@/views/roznamcha/tabs/allTransactions";

let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);
export default {
  props: ["account", "customer"],
  components: { sendTransfers,transfers, receiveTransfers, allTransactions },
  data: () => ({
    // transfers: [],
    tab: "balance",
    transactions: [],
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: currentDate.toLocaleDateString("en-ca"),
  }),

  computed: {
    transfers() {
      return this.transactions
        .filter((x) => x.src_type == "transfer")
        .map((item) => item.item);
    },
    sendTransfers() {
      return this.transactions
        .filter((x) => x.src_type == "transfer" && x.item.type != "receive")
        .map((item) => item.item);
    },
    receivedTransfers() {
      return this.transactions
        .filter((x) => x.src_type == "transfer" && x.item.type == "receive")
        .map((item) => item.item);
    },
  },

  methods: {
    saved(transaction) {
      this.$emit("update");
    },

    getTransactions(account) {
      this.axios
        .get(
          `account-transactions/${this.account.id}?start_date=${this.start_date}&end_date=${this.end_date}`
        )
        .then((res) => {
          this.transactions = res.data.transactions;
          this.account.balance = res.data.balance;
          this.account.opening_balance = res.data.opening_balance;
        })
        .catch((err) => {
          this.$router.push("/404");
        });
    },
  },

  watch: {
    account: {
      deep: true,
      handler() {
        this.getTransactions(this.account);
      },
    },
  },
  created() {
    this.getTransactions(this.account);
  },
};
</script>